/* tslint:disable */
/* eslint-disable */
/**
 * EMLINX API specification
 * This is API specification for EMLINX project.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import { ErrorResponse } from '../models';
// @ts-ignore
import { GetCaseResponse } from '../models';
/**
 * GetcaseApi - axios parameter creator
 * @export
 */
export const GetcaseApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get case
         * @summary GET Case
         * @param {number} id case\&#39;s ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCase: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getCase', 'id', id)
            const localVarPath = `/cases/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GetcaseApi - functional programming interface
 * @export
 */
export const GetcaseApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GetcaseApiAxiosParamCreator(configuration)
    return {
        /**
         * Get case
         * @summary GET Case
         * @param {number} id case\&#39;s ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCase(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCaseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCase(id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['GetcaseApi.getCase']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * GetcaseApi - factory interface
 * @export
 */
export const GetcaseApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GetcaseApiFp(configuration)
    return {
        /**
         * Get case
         * @summary GET Case
         * @param {number} id case\&#39;s ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCase(id: number, options?: any): AxiosPromise<GetCaseResponse> {
            return localVarFp.getCase(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * GetcaseApi - object-oriented interface
 * @export
 * @class GetcaseApi
 * @extends {BaseAPI}
 */
export class GetcaseApi extends BaseAPI {
    /**
     * Get case
     * @summary GET Case
     * @param {number} id case\&#39;s ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GetcaseApi
     */
    public getCase(id: number, options?: RawAxiosRequestConfig) {
        return GetcaseApiFp(this.configuration).getCase(id, options).then((request) => request(this.axios, this.basePath));
    }
}

